import React from "react";

export const Footer = () => {
  return (
    <footer className="bg-dark text-light py-3">
      <p className="text-center">Copyright &copy; MyTodosList.com</p>
    </footer>
  );
};
